import { createAvailabilityApiClient } from '@/infrastructure/prices/availability/availabilityApiClient';

export const availabilityApiClient = createAvailabilityApiClient({});
